import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { mapPlaceholderDtoToModel, PlaceholderModel } from './dto/Placeholder.dto';
export class PlaceholderApi {
  constructor(private client: AxiosInstance) {}

  fetch(projectId: number): Promise<PlaceholderModel[]> {
    return this.client
      .get(`/api/v1/project/${projectId}/email-template-placeholders`)
      .then(selectApiData)
      .then((entries) => entries.map(mapPlaceholderDtoToModel));
  }
}
